import { useMemo } from "react";
import { PATIENTS_PER_PAGE } from "../SettingsDeletedPatients.consts";
import { useDeletedPatientsQuery } from "../../../../api/queries/useDeletedPatientsQuery";

export function useDeletedPatients({ searchTerm }) {
  const {
    data,
    isLoading,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    refetch,
  } = useDeletedPatientsQuery({
    payload: {
      pageSize: PATIENTS_PER_PAGE,
      searchTerm,
    },
    options: {
      staleTime: 0,
    },
  });

  const patients = useMemo(() => {
    if (data && data.pages) {
      return data.pages
        .map((p) => p.patients)
        .reduce((r, p) => [...r, ...p], []);
    }
    return [];
  }, [data]);

  return {
    patients,
    isPatientsLoading: isLoading,
    isNextPatientsFetching: isFetchingNextPage,
    fetchNextPatients: fetchNextPage,
    hasMorePatients: hasNextPage,
    refetchPatients: refetch,
  };
}
